export const MAIN_ENV = {
  COUNTRY: process.env.REACT_APP_COUNTRY
};

export const ENV = {
  CO: {
    REACT_APP_COUNTRY: process.env.REACT_APP_COUNTRY,
    REACT_APP_HABI_WEB: process.env.REACT_APP_HABI_WEB,
    REACT_APP_HABI_API_URL_V2: process.env.REACT_APP_HABI_API_URL_V2,
    REACT_APP_ENDPOINT_LLAVERO_API_BASE_PATH: process.env.REACT_APP_ENDPOINT_LLAVERO_API_BASE_PATH,
    REACT_APP_ENDPOINT_LLAVERO_API_KEY: process.env.REACT_APP_ENDPOINT_LLAVERO_API_KEY,
    REACT_APP_ENDPOINT_FORM_API_POST_LATLNG2DIR: process.env.REACT_APP_ENDPOINT_FORM_API_POST_LATLNG2DIR,
    REACT_APP_GOOGLE_MAPS_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY,
    REACT_APP_BUCKET_IMG: process.env.REACT_APP_BUCKET_IMG_CO,
    REACT_APP_HABI_GA: process.env.REACT_APP_HABI_GA,
    REACT_APP_ENDPOINT_HABI_CMS_GLOBAL_API_BASE_PATH: process.env.REACT_APP_ENDPOINT_HABI_CMS_GLOBAL_API_BASE_PATH,
    REACT_APP_ENDPOINT_GLOBAL_CMS_PROPERTY_CARD: process.env.REACT_APP_ENDPOINT_GLOBAL_CMS_PROPERTY_CARD,
    REACT_APP_HABI_GLOBAL_API_CMS_KEY: process.env.REACT_APP_HABI_GLOBAL_API_CMS_KEY,
    REACT_APP_HABI_CMS_STRAPI_PROJECT: process.env.REACT_APP_HABI_CMS_STRAPI_PROJECT_CO,
    REACT_APP_STRAPI_BASE_PATH: process.env.REACT_APP_STRAPI_BASE_PATH,
    REACT_APP_BUSINESS_GLOBAL_API_BASE_PATH: process.env.REACT_APP_BUSINESS_GLOBAL_API_BASE_PATH,
    REACT_APP_BUSINESS_API_KEY: process.env.REACT_APP_BUSINESS_API_KEY_CO,
  },
  MX: {
    REACT_APP_COUNTRY: process.env.REACT_APP_COUNTRY,
    REACT_APP_HABI_WEB: process.env.REACT_APP_HABI_WEB,
    REACT_APP_HABI_API_URL_V2: process.env.REACT_APP_HABI_API_URL_V2,
    REACT_APP_ENDPOINT_LLAVERO_API_BASE_PATH: process.env.REACT_APP_ENDPOINT_LLAVERO_API_BASE_PATH,
    REACT_APP_ENDPOINT_LLAVERO_API_KEY: process.env.REACT_APP_ENDPOINT_LLAVERO_API_KEY,
    REACT_APP_ENDPOINT_FORM_API_POST_LATLNG2DIR: process.env.REACT_APP_ENDPOINT_FORM_API_POST_LATLNG2DIR,
    REACT_APP_GOOGLE_MAPS_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY,
    REACT_APP_BUCKET_IMG: process.env.REACT_APP_BUCKET_IMG_MX,
    REACT_APP_HABI_GA: process.env.REACT_APP_HABI_GA,
    REACT_APP_ENDPOINT_HABI_CMS_GLOBAL_API_BASE_PATH: process.env.REACT_APP_ENDPOINT_HABI_CMS_GLOBAL_API_BASE_PATH,
    REACT_APP_ENDPOINT_GLOBAL_CMS_PROPERTY_CARD: process.env.REACT_APP_ENDPOINT_GLOBAL_CMS_PROPERTY_CARD,
    REACT_APP_HABI_GLOBAL_API_CMS_KEY: process.env.REACT_APP_HABI_GLOBAL_API_CMS_KEY,
    REACT_APP_HABI_CMS_STRAPI_PROJECT: process.env.REACT_APP_HABI_CMS_STRAPI_PROJECT,
    REACT_APP_STRAPI_BASE_PATH: process.env.REACT_APP_STRAPI_BASE_PATH,
    REACT_APP_BUSINESS_GLOBAL_API_BASE_PATH: process.env.REACT_APP_BUSINESS_GLOBAL_API_BASE_PATH,
    REACT_APP_BUSINESS_API_KEY: process.env.REACT_APP_BUSINESS_API_KEY,
  },
};
